module.exports = __webpack_public_path__ + "static/img/title.a33b5b3c.png";